const PlayerObjectSkeleton: React.FC<{ bigHeader?: boolean }> = ({ bigHeader = false }) =>
  bigHeader ? (
    <div id='player' className='flex w-full animate-pulse items-start gap-2 self-stretch p-2 shadow'>
      <div className='flex h-16 w-16 rounded-xl bg-neutral-neutral-8 md:h-24 md:w-24' />
      <div id='player-main' className='flex flex-col flex-wrap items-start gap-2 self-stretch p-2'>
        <div id='player-name' className='flex items-start gap-2'>
          <div id='nome' className='h-8 w-64 bg-neutral-neutral-8 md:w-96'></div>
        </div>
        <div id='player-details' className='flex flex-col items-baseline gap-x-5 md:flex-row'>
          <div id='details1' className='flex h-8 w-20 items-baseline gap-2 bg-neutral-neutral-8'></div>
          <div id='details2' className='w-30 flex h-8 gap-2 bg-neutral-neutral-8'></div>
          <div id='details3' className='flex h-8 w-20 gap-2 bg-neutral-neutral-8'></div>
        </div>
      </div>
    </div>
  ) : (
    <div className='animate-pulse rounded-md py-2 shadow'>
      <div className='flex items-center gap-2 p-2'>
        <div className='flex h-8 w-8 items-center rounded-md bg-neutral-neutral-8'></div>
        <div className='flex gap-1'>
          <div className='mb-2 h-2.5 w-16 rounded-full bg-neutral-neutral-8'></div>
          <div className='mb-2 h-2.5 w-32 rounded-full bg-neutral-neutral-8'></div>
        </div>
      </div>
      <div className='px-2 text-xs text-neutral-neutral-9'>
        <div className='h-2 w-48 rounded-full bg-neutral-neutral-8'></div>
      </div>
    </div>
  );

export default PlayerObjectSkeleton;
